export const PENDING_AUTH = 'PendingAuth';
export const FUNCTIONALITY = 'functionality';
export const CLIENT_DATA = 'clientData';
export const EXECUTIVE_RUT = 'executiveRut';
export const EXECUTIVE_SESSION = 'executiveSession';
export const DEVICE_TYPE = 'deviceType';
